import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    {
      id: 1,
      link: 'home',
    },
    {
      id: 2,
      link: 'about',
    },
    {
      id: 3,
      link: 'projects',
    },
    {
      id: 4,
      link: 'skills',
    },
    {
      id: 5,
      link: 'contact',
    },
  ];

  return (
    <div className="h-20 bg-black text-white px-4 flex justify-between items-center w-full fixed">
      <a href="/" alt='logo'>
        <h1 className="text-5xl font-signature ml-2 cursor-pointer">Nidhi</h1>
      </a>

      <ul className="hidden md:flex">
        {links.map(
          (
            { id, link }, // Array Destructuring
          ) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize font-medium text-gray-400 hover:scale-105 duration-200"
            >
              {/* Link component added from smooth-scroll lib to scroll directly to the clicked nav item */}
              <Link to={link} smooth duration={500}>
                {link}
              </Link>
            </li>
          ),
        )}
      </ul>

      {/* Implementation of Mobile View */}
      <div
        onClick={() => {
          setNav(!nav);
        }}
        className="cursor-pointer pr-2 z-10 text-gray-500 md:hidden"
      >
        {/* z-10 = so that this div is always on top */}
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {/* Implementing List Menu for Mobile Version */}
      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-400 ">
          {links.map(
            (
              { id, link }, // Array Destructuring
            ) => (
              <li
                key={id}
                className="px-4 cursor-pointer capitalize py-6 text-4xl"
              >
                <Link
                  onClick={() => setNav(!nav)}
                  to={link}
                  smooth
                  duration={500}
                >
                  {link}
                </Link>
              </li>
            ),
          )}
        </ul>
      )}

      {/* On Desktop screens, hide hamburger menu */}
    </div>
  );
}

export default NavBar;
